import React from 'react'
import PropTypes from 'prop-types'
import styled, { rem, theme } from '@nobia/zeus-components/lib/styled'
// import settings from '@nobia/zeus-components/lib/settings'
import { PageTitle } from '@nobia/zeus-components/lib/typography'
import { injectIntl } from '@nobia/zeus-components/lib/i18n'
import { Row, Column } from '@nobia/zeus-components/lib/grid'
import {
  compose,
  withState,
  withHandlers,
} from '@nobia/zeus-components/lib/recompose'

const StyledPageTitle = styled(PageTitle)`
  color: ${theme('typography.pageTitle.color')};
  letter-spacing: ${theme('typography.pageTitle.letterSpacing')};
  line-height: ${theme('typography.pageTitle.lineHeight')};
  max-width: ${theme('typography.pageTitle.maxWidth')};
  margin-bottom: 0px;
  margin-top: 0px;
  font-size: ${theme('typography.pageTitle.fontSize')};
  text-transform: ${theme('typography.pageTitle.textTransform')};
  font-weight: ${theme('typography.pageTitle.fontWeight')};

  ${props => props.theme.media.min.sm`
    font-family: ${theme('typography.pageTitle.fontFamily')};
    width: 100%;
    max-width: ${theme('typography.pageTitle.maxWidthDesktop')};
    margin-top: ${rem(13)};
    letter-spacing: ${theme('typography.pageTitle.letterSpacingDesktop')};
    line-height: ${theme('typography.pageTitle.lineHeightDesktop')};
    font-size: ${theme('typography.pageTitle.fontSizeDesktop')};
    font-weight: ${theme('typography.pageTitle.fontWeight')};
  `};
`

const StyledPageDescription = styled.div`
  color: ${theme('typography.pageDescription.color')};
  letter-spacing: ${theme('typography.pageDescription.letterSpacing')};
  margin: ${rem(15)} ${rem(0)} ${rem(55)} ${rem(0)};
  font-size: ${theme('typography.pageDescription.fontSize')} !important;
  line-height: ${theme('typography.pageDescription.lineHeight')};
  font-weight: ${theme('typography.pageDescription.fontWeight')};
  margin-bottom: 20px;
  max-width: ${theme('typography.pageDescription.maxWidth')};
  ${props => props.theme.media.min.sm`
    max-width: ${theme('typography.pageDescription.maxWidthDesktop')};
    font-size: ${theme(
      'typography.pageDescription.fontSizeDesktop'
    )}; !important;
    letter-spacing: ${theme('typography.pageDescription.letterSpacingDesktop')};
    line-height: ${theme('typography.pageDescription.lineHeightDesktop')};
  `};
`

const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: ${theme('headerContainer.alignItems')};
  justify-content: center;
  max-width: ${theme('grid.containerMaxWidth')};
  flex-direction: column;
  text-align: ${theme('headerContainer.textAlign')};
`

const ContentHeader = ({ content }) => {
  const heading = content.heading?.value
  const descriptionHtml =
    content.mainBody?.value || content.preamble?.value || ''

  return (
    <Row>
      <Column>
        <HeaderContainer>
          {heading && <StyledPageTitle>{heading}</StyledPageTitle>}
          {descriptionHtml && (
            <StyledPageDescription
              dangerouslySetInnerHTML={{ __html: descriptionHtml }}
            />
          )}
        </HeaderContainer>
      </Column>
    </Row>
  )
}

ContentHeader.defaultProps = {
  content: null,
}

ContentHeader.propTypes = {
  content: PropTypes.shape({
    heading: PropTypes.shape({
      value: PropTypes.string,
    }),
    mainBody: PropTypes.shape({
      value: PropTypes.string,
    }),
    preamble: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
}

const enhance = compose(
  withState('detailsActive', 'toggleDetails', false),
  injectIntl,
  withHandlers({
    getString: ({ intl }) => (key, defaultMessage) =>
      intl.formatMessage({
        id: `app.header.${key}`,
        defaultMessage,
      }),
  })
)

export default enhance(ContentHeader)
